import request from '@/utils/request'


export function analysis(data) {
  return request({
    url: 'analysis/analysis',
    method: 'post',
    data
  })
}

export function processAnalysis(data) {
  return request({
    url: 'analysis/processAnalysis',
    method: 'post',
    data
  })
}


export function report(data) {
  return request({
    url: 'analysis/report',
    method: 'post',
    data
  })
}
